import { combineReducers } from "@reduxjs/toolkit";
import { myInfoReducer } from "./auth/my-info.slice";

export const rootReducer = combineReducers({
  myInfo: myInfoReducer,
});
